import React, { useEffect, useState } from "react";
import { Modal, Button, Table } from "antd";
import commonService from "@/service/common";
import moment from "moment";
import "./index.less";
const ProcessModal = (props) => {
  console.log(props, "props");
  const { processVisible, drawerData } = props;
  const [processBtnList, setProcessBtnList] = useState([]);
  const [processTableColumn, setProcessTableColumn] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [activeProcessType, setActiveProcessType] = useState(null);

  const handleOk = () => {
    props.handleProcessModalCancel();
  };
  const getProcessBtn = async () => {
    setTableLoading(true);
    let moudleParams = {
      collection: "cfg-web-miceProcess",
      filter: {
        type: "processBtnList",
      },
      projection: {
        btnList: 1,
      },
    };
    let res = await commonService.GetSettings(moudleParams);
    if (res && res.success) {
      let brnList = (res.content.btnList || []).filter(
        (item) => !item.hidden.includes(drawerData.tenantCode),
      );
      setProcessBtnList(brnList);
      if (brnList.length > 0) {
        const defaultType = brnList[0].val;
        setActiveProcessType(defaultType);
        getProcessTableColumn(defaultType);
      } else {
        setTableLoading(false);
      }
    } else {
      setTableLoading(false);
    }
  };
  const processTypeColumnMap = {
    1: "processMainColumn",
    2: "processVenueColumn",
    3: "processCarColumn",
  };
  const handleBtnClick = (val) => {
    setActiveProcessType(val);
    getProcessTableColumn(val);
  };
  const getProcessTableColumn = async (processType) => {
    let moudleParams = {
      collection: "cfg-web-miceProcess",
      filter: {
        type: processTypeColumnMap[processType],
      },
      projection: {
        Column: 1,
      },
    };
    let res = await commonService.GetSettings(moudleParams);
    if (res && res.success) {
      let columnData = res.content.column;
      setProcessTableColumn(columnData);
      if ([1].includes(processType)) {
        getProcessTableData();
      } else {
        getCarOrHotelData(processType);
      }
    } else {
      setTableLoading(false);
    }
  };
  const getProcessTableData = async () => {
    let tenant = drawerData.tenantCode;
    const flowCode =
      tenant === "crossevent"
        ? "CrossEvent-GROUP"
        : `TMIS-${tenant.toUpperCase()}`;
    const funName =
      tenant === "crossevent"
        ? "QueryMiceProcessTaskLogs"
        : "QueryAccessTaskLogs";
    let params = {
      filters: {
        processId: drawerData.miceId,
        businessId: drawerData.miceId,
        nodeTypes: "1,5,6",
        sort: "desc",
      },
    };
    if (["crossevent"].includes(tenant)) {
      params.filters.category = flowCode;
    } else {
      params.filters.flowCode = flowCode;
    }
    if (
      ["交际费"].includes(drawerData.typeDictTxt) &&
      ["dscl"].includes(tenant)
    ) {
      params.filters.flowCode = "TMIS-DSCL-Communication";
    }
    let res = await commonService[funName](params);
    if (res && res.success) {
      setTableData(res.content);
      setTableLoading(false);
    } else {
      setTableLoading(false);
    }
  };
  const getCarOrHotelData = async (processType) => {
    let params = {
      ProposalId: drawerData.miceId,
      TypeDictVal: "V2",
    };
    let paramsLog = {
      ProposalId: drawerData.miceId,
      FlowCodes:
        processType == 2
          ? ["venue.supplier.quote", "venue.supplier.settle"]
          : ["R-Car-Offline"],
    };
    let res =
      await commonService[processType == 2 ? "QueryOrders" : "QueryCarOrders"](
        params,
      );

    let resLog =
      await commonService[
        processType == 2 ? "SupplierTaskLogs" : "SupplierCarTaskLogs"
      ](paramsLog);
    setTableData(getData(res.content, resLog.content));
    setTableLoading(false);
  };
  const getData = (val1, val2) => {
    let dataListCopy = [];
    val1.forEach((item) => {
      let list = [];
      val2.forEach((items) => {
        if (item.supplierId === items.id) {
          items.createdOn = moment(items.createdOn).format(
            "yyyy-MM-dd HH:mm:ss",
          );
          items.doneOn = moment(items.doneOn).format("yyyy-MM-dd HH:mm:ss");
          items.taskStatusTxt = items.taskStatus == 1 ? "已办" : "待办";
          list.push(items);
        }
      });
      let listCopy = {};
      listCopy.list = list;
      listCopy.title = item.name;
      listCopy.isShow = true;
      dataListCopy.push(listCopy);
    });
    return dataListCopy;
  };

  useEffect(() => {
    getProcessBtn();
  }, [drawerData]);

  return (
    <Modal
      title="进程"
      visible={processVisible}
      onOk={handleOk}
      width={1000}
      onCancel={handleOk}
    >
      <div className="process-btn-container">
        {processBtnList.map((item, index) => (
          <Button
            onClick={() => handleBtnClick(item.val)}
            className={activeProcessType === item.val ? "active" : ""}
            key={index}
          >
            {item.txt}
          </Button>
        ))}
      </div>
      <div className="process-table-wrapper">
        <Table
          rowKey="key"
          columns={processTableColumn}
          dataSource={tableData}
          loading={tableLoading}
          scroll={{ x: "max-content" }}
          pagination={false}
        />
      </div>
    </Modal>
  );
};

export default ProcessModal;
